
// API请求前缀
export const apiPrefix = '/ec';
